import React from 'react';
import PropTypes from 'prop-types';
import {
  Col,
  Button,
} from 'athenaeum';
import cx from 'classnames';
import {
  parseAttributes,
  openEasyQuiz
} from 'contentfulPages/components/CTA/utils';
import { trackClickedCTA } from 'utils/analytics/track';
import styles from './cta.module.scss';

import CaptureCTA from './CaptureCTA';

const CTA = (props) => {
  const {
    type,
    colProps,
    actionPath,
    buttonText,
    hide,
    id,
    className,
    attributes,
    stickyNavButtonId,
    ctaStyle
  } = props;

  const hideCTAclass = hide ? styles.secondCTA : '';

  const classes = cx(
    hideCTAclass,
    type === 'single-button' && styles['single-button'],
    className,
  );

  // TODO After button is refactored in athenaeum to allow on click for <a> tags, remove Column onClick
  if (type === 'single-button') {
    const dataAttributes = parseAttributes(attributes);
    const activateEasyQuiz = dataAttributes['data-easy-quiz'];
    const path = activateEasyQuiz ? null : actionPath;
    return (
      <div
        data-type="cta-button"
        id="cta-single-button"
      >
        <Col
          {...colProps}
          className={classes}
          fullwidth
          onClick={() => {
            if (activateEasyQuiz) {
              openEasyQuiz();
            }
            trackClickedCTA(id);
          }}
        >
          <Button
            linkAttrs={{
              href: path,
              target: '',
              id: stickyNavButtonId,
              ...dataAttributes
            }}
            outline={ctaStyle === 'Black Outline'}
            variant={ctaStyle === 'Black Outline' ? 'info' : 'default'}
          >
            {buttonText}
          </Button>
        </Col>
      </div>
    );
  }

  return (
    <CaptureCTA
      {...props}
      id={id}
      className={classes}
    />
  );
};

CTA.propTypes = {
  /**
   * This prop will add a new className to any inherent classNames
   * provided in the component's index.js file.
   */
  className: PropTypes.string,
  buttonText: PropTypes.string,
  actionPath: PropTypes.string,
  type: PropTypes.string,
  colProps: PropTypes.object,
  hide: PropTypes.bool,
  id: PropTypes.string,
  attributes: PropTypes.string,
  stickyNavButtonId: PropTypes.string,
  ctaStyle: PropTypes.string,
};

export default CTA;



// WEBPACK FOOTER //
// ../src/components/CTA/index.js